import React, { Component } from 'react';
import Header from './../common/Header';
import Loader from './../common/Loader';
import '../../index.css';
import { connect } from 'react-redux';
import { fetchUserList } from '../../actions/UserDetails/UserAction';
import { fetchArticles } from '../../actions/Articles/ArticleAction';

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    componentWillMount() {
        const { users } = this.props;
        this.props.fetchUserList(users);
        this.props.fetchArticles(users);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 400);
    }

    render() {
        const { loading } = this.state;
        return (
            <div>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div>
                            <div className="row" style={{ margin: 20 }}>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#F39C12' }}>
                                            <i className="fa fa-users" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      TOTAL USERS
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      {this.props.userList.length}
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#00C0EF' }}>
                                            <i className="fa fa-file-text-o" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      NO. OF ARTICLES
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      {this.props.articleList.length}
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#DD4B39' }}>
                                            <i className="fa fa-calendar" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      NO. OF EVENTS PUSHED
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      1
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#FF851B' }}>
                                            <i className="fa fa-shopping-cart" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      NO. OF PRODUCT PUSHED
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      2
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#0073B7' }}>
                                            <i className="fa fa-map-marker" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      TOTAL KABADIWALLA ONBOARD
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      290
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ padding: 10 }}>
                                    <div className="col" style={styles.divStyle}>
                                        <div className="iconDivStyle" style={{ backgroundColor: '#00A65A' }}>
                                            <i className="fa fa-search-plus" aria-hidden="true" style={styles.iconStyle} />
                                        </div>
                                        <div className="col">
                                            <div>
                                                   <span style={styles.titleStyle}>
                                                      KABADIWALLA HIT <br />TODAY BY
                                                   </span>
                                            </div>
                                            <div>
                                                   <span style={styles.numberStyle}>
                                                      0 times
                                                   </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    divStyle: {
        paddingLeft: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconStyle: {
        fontSize: 45,
        color: '#fff'
    },
    titleStyle: {
        fontFamily: 'Source Sans Pro',
        fontSize: 14
    },
    numberStyle: {
        fontFamily: 'Source Sans Pro-SemiBold',
        fontSize: 18
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        userList: state.userList.userData,
        articleList: state.article.articleData
    };
}

export default connect(mapStateToProps, { fetchUserList, fetchArticles })(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js